import Vue from 'vue';
// Domain
import {
  GoalDefinitionStepStateManager,
} from '@/modules/flagship/goal-definition-step/domain/state/goal-definition-step-state-manager';
import GoalDefinitionStepState
  from '@/modules/flagship/goal-definition-step/domain/state/goal-definition-step-state';
import Injectable from '@/modules/shared/domain/di/injectable';
import Observer from '@/modules/shared/domain/observer/observer';

@Injectable()
export default class GoalDefinitionStepVueStateManager implements GoalDefinitionStepStateManager {
  private _state: GoalDefinitionStepState =
    Vue.observable<GoalDefinitionStepState>(new GoalDefinitionStepState());

  private readonly observers: Observer[] = [];

  get state(): GoalDefinitionStepState {
    return this._state;
  }

  set state(value: GoalDefinitionStepState) {
    this._state = value;
    this.notifyAll();
  }

  patch(state: Partial<GoalDefinitionStepState>) {
    type Keys = keyof GoalDefinitionStepState;
    Object.entries(state).forEach(([key, value]) => {
      const accessor = key as Keys;

      if (value !== undefined) {
        // eslint-disable-next-line
        // @ts-ignore @typescript-eslint/ban-ts-ignore
        this.state[accessor] = value;
      }
    });
  }

  notifyAll() {
    this.observers.forEach((observer) => observer.notify());
  }

  register(observer: Observer) {
    this.observers.push(observer);
  }
}
